import React from 'react';

type ReservationLimitPeriodContext = {
  totalWaitingAndShippedReservations: number;
  totalReservedAndCheckedInReservations: number;
  totalCompletedPromotions: number;
  periodStartDate: string;
  periodEndDate: string;
  getReservationsLimitInPeriodHandle: () => void;
};

export const ReservationLimitInPeriodContext = React.createContext<
  ReservationLimitPeriodContext | undefined
>(undefined);

export const useReservationLimitInPeriodContext = () => React.useContext(ReservationLimitInPeriodContext);
